import React, { useState, useRef, useEffect } from "react";
import ball from './assets/ball.webp';
import me from './assets/me.jpg';
import july from './assets/july.png';
import gif from './assets/gif.png';
import wops from './assets/Branding/wops.png';
import hey from './assets/hey.png';
import './main.css';
import { Link } from 'react-router-dom';
import emailjs from '@emailjs/browser';



const NewPortfolio = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); //for scroll to the top always I mean whenever the page opens the page will be at the top


    const [isOverlayVisible, setOverlayVisible] = useState(false);

    const toggleOverlay = () => {
        setOverlayVisible(!isOverlayVisible);
    };

    const form = useRef();
    const [notification, setNotification] = useState("");

    const sendEmail = (e) => {
        e.preventDefault();

        // Get form data
        const formData = new FormData(form.current);
        const name = formData.get("user_name");
        const email = formData.get("user_email");
        const subject = formData.get("user_subject");
        const message = formData.get("message");

        // Check if any field is empty
        if (!name || !email || !subject || !message) {
            setNotification("All fields are required!");
            setTimeout(() => setNotification(""), 3000); // Hide notification after 3 seconds
            return;
        }

        emailjs
            .sendForm('service_mh1ddkn', 'template_2zi8jcs', form.current, 'dBrGazk0t-K47QR2W')
            .then(
                () => {
                    setNotification("Message sent successfully!");
                    form.current.reset(); // Reset form fields
                    setTimeout(() => setNotification(""), 3000); // Hide notification after 3 seconds
                },
                (error) => {
                    setNotification("Failed to send message. Try again!");
                    setTimeout(() => setNotification(""), 3000); // Hide notification after 3 seconds
                    console.log("FAILED...", error.text);
                }
            );
    };


    // mouse cursor
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [hovered, setHovered] = useState(false);

    useEffect(() => {
        const handleMouseMove = (e) => {
            setPosition({ x: e.clientX, y: e.clientY });
        };

        document.addEventListener("mousemove", handleMouseMove);

        return () => {
            document.removeEventListener("mousemove", handleMouseMove);
        };
    }, []);

    useEffect(() => {
        const clickableElements = document.querySelectorAll("button, a, .logo, svg");

        clickableElements.forEach((element) => {
            element.addEventListener("mouseenter", () => setHovered(true));
            element.addEventListener("mouseleave", () => setHovered(false));
        });

        return () => {
            clickableElements.forEach((element) => {
                element.removeEventListener("mouseenter", () => setHovered(true));
                element.removeEventListener("mouseleave", () => setHovered(false));
            });
        };
    }, []);
    


    return (
        <div className="main-container">
            <div className={`cursor ${hovered ? "cursor-hover" : ""}`} style={{ left: `${position.x}px`, top: `${position.y}px` }} />
            <div className="navbar" >
                <p className="logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ cursor: 'none' }}>pranav.</p>
                <svg onClick={toggleOverlay} width="30" height="25" viewBox="0 0 30 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="30" height="5" rx="2.5" fill="#101010" />
                    <rect y="10" width="30" height="5" rx="2.5" fill="#101010" />
                    <rect y="20" width="30" height="5" rx="2.5" fill="#101010" /></svg>

                <ul className={`overlay ${isOverlayVisible ? "show" : ""}`}>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/">home.</Link></li>
                    </div>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/allprojects">project.</Link></li>
                    </div>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/about">about.</Link></li>
                    </div>
                    <div className="anim">
                        <div className="dot-anim"></div>
                        <li><Link to="/contact">contact.</Link></li>
                    </div>
                    <div className="available">
                        <div className="dot-green"></div>available for freelance.
                    </div>
                </ul>
            </div>

            <div className="hero" id="home">
                <p>i am a versatile creative</p>
                <h1>visual designer.</h1>
            </div>

            <div className="textandbutton">
                <p>a creative guy with passion for design :)</p>
                <div className="right">
                    <Link to="./contact"><button>get in touch.</button></Link>
                    <p><div className="dot-green"></div>available for freelance.</p>
                </div>
            </div>

            <div className="gif">
                <img src={ball} />
            </div>

            <div className="masterpieces" id="projects">
                <h2>my masterpieces.</h2>

                <Link to="/heyboost" className="highlights">
                    <div className="highlights">
                        <div className="project">
                            <div className="dot"></div>
                            <h1>hey boost.</h1>
                            <div className="contents">
                                <p>branding.</p>
                                <p>mockups.</p>
                            </div>
                            <Link to="/wops" className="explore"><button className="explore" >explore.</button></Link>
                        </div>
                        <img className="heyboost" src={hey} />
                    </div>
                </Link>

                <Link to="/wops" className="highlights">
                    <div className="highlights">
                        <div className="project">
                            <div className="dot"></div>
                            <h1>world of perfumers.</h1>
                            <div className="contents">
                                <p>branding.</p>
                                <p>ui/ux.</p>
                                <p>package designing.</p>
                            </div>
                            <Link to="/wops" className="explore"><button className="explore" >explore.</button></Link>
                        </div>
                        <img src={wops} />
                    </div>
                </Link>

                <Link to="/gif" className="highlights">
                    <div className="highlights">
                        <div className="project">
                            <div className="dot"></div>
                            <h1>gif.</h1>
                            <div className="contents">
                                <p>package design.</p>
                                <p>mockups.</p>
                            </div>
                            <button className="explore">explore.</button>
                        </div>
                        <img src={gif} />
                    </div>
                </Link>

                <Link to="/july" className="highlights">
                    <div className="highlights">
                        <div className="project">
                            <div className="dot"></div>
                            <h1>july.</h1>
                            <div className="contents">
                                <p>mockups.</p>
                                <p>3d model.</p>
                                <p>package designing.</p>
                            </div>
                            <button className="explore">explore.</button>
                        </div>
                        <img src={july} />
                    </div>
                </Link>

                <div className="explore-all">
                    <div className="fade-in">
                        <h1>more.</h1>
                        <p>journey through my portfolio, showcasing a blend of refined artistry and bold experimentation that defines my creative vision.</p>
                        <button> <Link to="/allprojects">explore.</Link></button>
                    </div>
                </div>
            </div>

            <div className="aboutt" id="about">
                <h1>about.</h1>
                <div className="about">
                    <div className="aboutme">
                        <div className="details">
                            <h1>pranav.</h1>
                            <p>hi, my name is Pranav Pradeep, a visual designer who transforms ideas into compelling visuals. whether crafting sleek logos or vibrant campaigns, I’m all about making brands stand out with style and creativity.</p>
                            <button><Link to="/about">about me.</Link></button>
                        </div>
                        <div className="contents">
                            <p className="service"><div className="dot-green"></div>available for freelance.</p>
                        </div>
                    </div>
                    <div className="me">
                        <img src={me} />
                    </div>
                </div>
            </div>

            <div className="missed-heading" id="contact">
                <h1>say hi.</h1>
                <div id="getintouch" className="sayhi">
                    <div className="contact-title">
                        <h1>let’s collaborate.</h1><br />
                        <p>have any idea in your mind?</p>
                        <p>fell free to reach out.</p>
                    </div>
                    <form className="contact" ref={form} onSubmit={sendEmail}>
                        <div className="textboxes">
                            <p>name.</p>
                            <input name="user_name" placeholder="John Doe" maxlength="25"></input>
                        </div>
                        <div className="textboxes">
                            <p>email.</p>
                            <input name="user_email" type="email" placeholder="example@gmail.com" maxlength="25"></input>
                        </div>
                        <div className="textboxes">
                            <p>subject.</p>
                            <input name="user_subject" placeholder="project abc" maxlength="25"></input>
                        </div>
                        <div className="textboxes">
                            <p>message.</p>
                            <input name="message" className="message" placeholder="I want your help in..." id=""></input>
                        </div>
                        <button type="submit" className="submit">submit.</button>
                    </form>
                </div>
            </div>


            {notification && (
                <div className="popup">
                    <p>{notification}</p>
                </div>
            )}


            <footer>
                <p>designed and developed by</p>
                <ul>pranav pradeep.</ul>
            </footer>
        </div>
    )
};
export default NewPortfolio;